import * as React from "react";
import './../App.css';
import {useEffect} from "react";
import {CurrentUser, UserType} from "../types/Types";
import {useNavigate} from "react-router";

interface Props {
  currentUser: CurrentUser
}

function LandingPage(props: Props) {
  const navigate = useNavigate()
  useEffect(() => {
    if(props.currentUser.userType == UserType.LOCATION_MANAGER) {
      navigate(`/business/${props.currentUser.business}`);
    } else if(props.currentUser.userType == UserType.CUSTOMER) {
      navigate(`/locations`);
    }
  }, [props.currentUser]);

  return (
      <>
      </>
  );
}

export default LandingPage;